import styled from '@emotion/styled';

export const SContainer = styled.div`
  width: 306px;
  padding: 13px;
`;

export const STitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
`;
